import React from 'react'
import '../Styles/World_visiting_place.css'
import worldImage from '../Images/visiting_place_world.png';
import RightArrowIcon from '../Images/ArrowCircleRight.png'
import { useNavigate } from 'react-router-dom'

function World_visiting_place() {
  const navigate = useNavigate();
  return (
    <div className='World_visiting_place'>
        <div className='world_visiting_place_heading'>
            <h1 style={{textAlign:"center",color:"white",padding:"2rem"}}>Here from different Places all over the World</h1>
              <button className="get-started" id='world_start_button' onClick={()=>{navigate("/tour/packagetour")}}><span onClick={()=>{navigate("/tour/packagetour")}}>Choose Package and Enjoy</span><span style={{ display: "flex", alignItems: "center" }}><img src={RightArrowIcon} alt='icon' width="25px" height="25px" /></span></button>
           <div className='World_img'><img src={worldImage}/></div> 
            </div>
    </div>
  )
}

export default World_visiting_place